import { requst } from '../config'

// 字典数据树
export const getSOURCEDictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}

/* 通过 preplotLine 查询数据库中相同preplotLine数量 */
export const getPreplotLineCountApi = (projectId, preplotLine) => {
    const url = `/countPreplotLine/${projectId}/${preplotLine}`
    return requst.get(url)
}

/* 获取项目上一个拖缆sequence的付费cmp线束号 */
export const getLastChargedLinesApi = (projectId, locationId, sequence) => {
    const url = `/monitor/acquisition/streamer/getLastChargedLines?projectId=${projectId}&locationId=${locationId}&sequence=${sequence}`
    return requst.get(url)
}

/* 获取Preplot线的开始结束点位号 */
export const getPreplotStartAndEndPointApi = (line, preplotId) => {
    const url = `/monitor/acquisition/streamer/getPreplotStartAndEndPoint?line=${line}&preplotId=${preplotId}`
    return requst.get(url)
}